import { Campaign as GraphQLResponseCampaigns } from '@phrasee/phrasee-typings/Graphql/interfaces'
import { gql } from 'graphql-request'

import { fetchGraphQL } from 'common/api'
import {
  ResponseDistributionChannel,
  ResponseDistributionType,
  ResponseStatus,
} from 'common/interfaces/campaign'

export interface ResponseCampaign
  extends Pick<
    GraphQLResponseCampaigns,
    | '_id'
    | 'name'
    | 'created'
    | 'status'
    | 'send_date'
    | 'campaign_configuration'
    | 'user_id'
    | 'campaignOwner'
    | 'project'
    | 'grammar_id'
  > {
  _id: string
  name: string
  created: string
  send_date?: string
  campaign_configuration: {
    distribution_channel: ResponseDistributionChannel
    distribution_type?: ResponseDistributionType
  }
  status: ResponseStatus
  user_id: string
  campaignOwner?: { _id: string; fname?: string; lname?: string }
  project: { _id: string; name: string }
  grammar_id: string
  is_mismatching_configuration?: boolean
}

export interface CampaignsResponse {
  campaigns: ResponseCampaign[]
  count: number
}

export async function fetchActivePersonalizedCampaigns(
  accountId: string
): Promise<CampaignsResponse> {
  const query = gql`
    query campaigns($page: Int, $pageSize: Int, $filter: CampaignFilter) {
      data: campaigns(page: $page, pageSize: $pageSize, filter: $filter) {
        campaigns {
          _id
          name
          campaign_configuration {
            distribution_channel
          }
          created
          status
          send_date
          user_id
          grammar_id
          campaignOwner {
            fname
            lname
          }
          project {
            _id
            name
          }
        }
        count
      }
    }
  `

  const variables = {
    filter: {
      accountId,
      includeDeleted: false,
      includeArchived: false,
      isPersonalizationEnabled: true,
    },
  }

  return fetchGraphQL<CampaignsResponse>({ query, variables }, {})
}

export const fetchHeaders = async (accountId: string) => {
  return Promise.resolve({
    useCase: [
      { displayName: 'Abandon cart', value: 'abondon_cart' },
      { displayName: 'use case 2', value: 'use_case_2' },
    ],

    channels: [
      { displayName: 'Email subject line', value: 'email_subject_line' },
      { displayName: 'channel2', value: 'channel2' },
    ],
  })
}

export const fetchSelectedFilters = async (accountId: string) => {
  return Promise.resolve({
    useCase: 'abondon_cart',
    channel: 'email_subject_line',
  })
}

export const fetchGraphs = async (accountId: string) => {
  return Promise.resolve([
    { displayName: 'Contextual lines served1', value: 100213 },
    { displayName: 'Contextual lines served2', value: 100213 },
    { displayName: 'Contextual lines served3', value: 100213 },
    { displayName: 'Contextual lines served4', value: 100213 },
    { displayName: 'Contextual lines served5', value: 100213 },
    { displayName: 'Contextual lines served6', value: 100213 },
    { displayName: 'Contextual lines served7', value: 100213 },
    { displayName: 'Contextual lines served8', value: 100213 },
    { displayName: 'Contextual lines served9', value: 100213 },
    { displayName: 'Contextual lines served10', value: 100213 },
    { displayName: 'Contextual lines served11', value: 100213 },
    { displayName: 'Contextual lines served12', value: 100213 },
    { displayName: 'Contextual lines served13', value: 100213 },
  ])
}
